<template>
  <div>
    <p>{{ $t('i18n.1647915861388') }}</p>
    <el-radio-group v-model="radio" @change="handleChange">
      <div style="margin-top: 20px;">
        <el-radio label="2">{{ $t('i18n.1647915903236') }}</el-radio>
      </div>
      <div style="margin-top: 20px; margin-bottom: 20px;">
        <el-radio label="1">{{ $t('i18n.1647915911599') }}</el-radio>
      </div>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: '2'
    }
  },
  created() {
    this.$emit('change', this.radio)
  },
  methods: {
    handleChange(v) {
      this.$emit('change', v)
    }
  }
}
</script>
